import React, { useContext, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import MonitoringTitleBarViewModel from "./ViewModels/MonitoringTitleBarViewModel";
import { MsalContext } from '../Contexts/MsalContext';
import Button from "@mui/material/Button";
import TagsContainer from "../CallInfo/TagsDisplay/TagsContainer";
import Alert from "@mui/material/Alert";
import { useLocation } from 'react-router-dom';
import useMediaQuery from "@mui/material/useMediaQuery";
import { formatDate } from "../Utilities/UtilityMethods";

interface IProps {
    id: string;
    close: () => void | ((customerId: string, date: Date) => void);
    isQA: boolean;
    isDataDialler: boolean;
    isAdmin: boolean;
    isClient: boolean;
    isUsersCall?: boolean;
    showBackButton: boolean;
}

export default function MonitoringTitleBar(props: IProps) {
    let location = useLocation();
    const { msalFetch } = useContext(MsalContext);
    const [titleBarData, setTitleBarData] = useState<MonitoringTitleBarViewModel>(new MonitoringTitleBarViewModel())
    const theme = useTheme();

    useEffect(() => {
        if (props.id) {
            getData();
        }
    }, [props.id])

    const getData = () => {
        console.log(location.pathname)
        msalFetch(`api/MonitoringCallInfo/GetTitleBar?systemPk=${props.id}`)
            .then(response => response.json())
            .then(Data => {
                setTitleBarData(Data.value);
            });
    }

    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));


    return (
        <AppBar position="static" color="default" >
            <Toolbar variant="dense">
                {props.showBackButton &&
                    <Button variant="outlined" onClick={props.close} sx={{ ml: -2, mr: 2 }}>Back</Button>
                }
                <Typography variant="body1" component="div" sx={{ flexGrow: 1, width: 'min-content' }}>
                    {titleBarData.client}
                    - {titleBarData.channel}
                    {!isSmallScreen && `- ${titleBarData.customerId}`}
                    - {titleBarData.telephone}
                    {!isSmallScreen && `- ${titleBarData.agentName}`}
                    - {formatDate(titleBarData.eventTime)}
                    - {new Date(titleBarData.eventTime).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                    - {titleBarData.result}
                </Typography>
                {((props.isQA || props.isDataDialler || props.isAdmin) && !props.isClient) &&
                    <TagsContainer systemPK={props.id!} />
                }
            </Toolbar>
            {
                props.isUsersCall === false &&
                <Alert severity="warning">This is another agent's call. Some information may be restricted.</Alert>
            }
        </AppBar>
    );
}